import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetKnowledgeBase, KnowledgeBaseSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof KnowledgeBaseSchema>>

const getKnowledgeBaseQueryKey = (query?: z.infer<typeof GetKnowledgeBase>) => [
  "knowledgeBase",
  query,
]

type Params = {
  query: z.infer<typeof GetKnowledgeBase>
  onSuccess?: (data: Response) => void
}

export const knowledgeBaseQuery = (params?: Params) => {
  return queryOptions({
    queryKey: getKnowledgeBaseQueryKey(params?.query),
    queryFn: async () => {
      const response = await axios.get<Response>(`/knowledgeBase`, {
        params: params?.query,
      })

      if (params?.onSuccess) {
        params.onSuccess(response.data)
      }

      return response.data.data
    },
    refetchInterval: (queryInstance) => {
      const data = queryInstance.state.data
      if (!data) return

      if (data.some((item) => item.isRetrieving)) return 3000
    },
  })
}
